module.exports = __webpack_public_path__ + "img/mascot_tq.a53be05c.png";